var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseElFormItem',{attrs:{"label":"發送渠道","prop":`NotifySettings[${_vm.notifyIndex}].channels`}},[_c('BaseElCheckboxGroup',{model:{value:(_vm.syncValue),callback:function ($$v) {_vm.syncValue=$$v},expression:"syncValue"}},[_c('BaseElCheckbox',{attrs:{"label":"LINE"}},[_vm._v("Line")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }